import styled from 'styled-components'
import { P } from 'konsys-ui'
import { theme, media } from '../../styles/_variables'
import { WidthContainer as Wc } from '../../components/container/styled'

export const WidthContainer = styled(Wc)`
  padding: 40px 16px;
  text-align: center;
  ${media.tablet`
    padding: 24px 16px;
    text-align: left;
    > div > div:last-child {
      text-align: center;
    }
    .input > div {
      width: 100%;
    }
  `}
`

export const ResendMail = styled(P)`
  color: ${theme.color.primaryColor};
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.5s ease;
  &:hover {
    color: ${theme.color.tertiaryColor};
  }
`

export default WidthContainer



// WEBPACK FOOTER //
// ./src/pages/register/styled.js